import {
    CREATE_EDIT_SCHEDULED_ACTION_OPEN_MODAL,
    CREATE_EDIT_SCHEDULED_ACTION_REQUEST,
    CREATE_EDIT_SCHEDULED_ACTION_RESULT,
    CREATE_EDIT_SCHEDULED_ACTION_GET_DETAIL_REQUEST,
    CREATE_EDIT_SCHEDULED_ACTION_GET_DETAIL_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    openModal: false,
    loading: false,
    id: null,
    result: null,
    detail: null
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {

        case CREATE_EDIT_SCHEDULED_ACTION_OPEN_MODAL:
            return { ...state, openModal: action.payload.open, id: action.payload.id }

        case CREATE_EDIT_SCHEDULED_ACTION_REQUEST:
            return { ...state, loading: true }

        case CREATE_EDIT_SCHEDULED_ACTION_RESULT:
            return { ...state, loading: false, result: action.payload }

        case CREATE_EDIT_SCHEDULED_ACTION_GET_DETAIL_REQUEST:
            return { ...state, loading: true }

        case CREATE_EDIT_SCHEDULED_ACTION_GET_DETAIL_RESULT:
            return { ...state, loading: false, detail: action.payload }

        case CLEAR_REDUX:
            return ["", "CREATE_EDIT_SCHEDULED"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};